module.exports = __webpack_public_path__ + "media/images/clse-white-d9f972e198c05d5d363f6ea95e2dbf22.png";